export default __webpack_public_path__ + "static/media/road-hazard-other.99d03c87.svg";